/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_median.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts a multivalued field into a single valued field containing the median value.
 *
 * @example
 * ROW a=[3, 5, 1]
 * | EVAL median_a = MV_MEDIAN(a)
 *
 * @example
 * ROW a=[3, 7, 1, 6]
 * | EVAL median_a = MV_MEDIAN(a)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'mv_median',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'unsigned_long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
